import { SupportedChainId } from 'config/chains'

export enum FORM_TYPES {
  SWAP = 'swap',
  TWAP = 'twap',
  MULTI = 'multi',
  LIMIT = 'limit',
  STOP_LOSS = 'stop-loss',
  TAKE_PROFIT = 'take-profit',
}
// The host selects eligible networks; SpotProvider validates their server configuration.
export const TWAP_DEFAULT_CHAIN_ID = SupportedChainId.BERA
export const TWAP_CHAIN_IDS: readonly number[] = [SupportedChainId.BERA, SupportedChainId.ROBINHOOD]
export function isTwapSupportedChain(chainId: number | undefined): boolean {
  return chainId !== undefined && TWAP_CHAIN_IDS.includes(chainId)
}

export const TWAP_FORMS = [FORM_TYPES.TWAP, FORM_TYPES.LIMIT, FORM_TYPES.STOP_LOSS, FORM_TYPES.TAKE_PROFIT]
